module.exports = __webpack_public_path__ + "img/pdf.3dc77f9b.png";